'use strict';

var skeleton = require('../../../../../../../../../../_virtual/skeleton.cjs');

(function (exports) {

	exports.SkeletonAviaryTypes = void 0;
	(function(SkeletonAviaryTypes) {
	    SkeletonAviaryTypes["button"] = "button";
	    SkeletonAviaryTypes["typography"] = "typography";
	    SkeletonAviaryTypes["avatar"] = "avatar";
	})(exports.SkeletonAviaryTypes || (exports.SkeletonAviaryTypes = {}));
	
} (skeleton.__exports));
//# sourceMappingURL=skeleton.cjs.map
